import { useState, useEffect } from 'react';

export function AdPlacement() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="webhook-section p-4">
        <div className="animate-pulse space-y-4">
          <div className="h-4 bg-neon-webhook-muted rounded w-3/4"></div>
          <div className="h-4 bg-neon-webhook-muted rounded"></div>
          <div className="h-4 bg-neon-webhook-muted rounded w-5/6"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="webhook-section p-4">
      <div className="terminal-header">
        <h3 className="text-sm font-mono" style={{ color: 'var(--theme-color)' }}>Support TestHook</h3>
        <div className="flex space-x-2">
          <span className="webhook-badge">Open Source</span>
          <span className="webhook-badge">Community</span>
        </div>
      </div>
      <div className="text-hacker-text-muted text-xs mt-3">
        <p>TestHook is a free and open-source project. It is my contribution to the developer ecosystem. Feel free to use, modify, and contribute to make it better for everyone.</p>
        <div className="mt-4 space-y-3">
          <a
            href="https://github.com/okuobongntuk/testhook"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center webhook-button"
          >
            <svg className="w-4 h-4 inline-block mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
            </svg>
            Contribute on GitHub
          </a>
          <a
            href="https://flutterwave.com/pay/fund-testhook"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center webhook-button"
          >
            <svg className="w-4 h-4 inline-block mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
            </svg>
            Sponsor Project
          </a>
          <a
            href="https://flutterwave.com/pay/testhook-coffee"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center webhook-button"
          >
            <svg className="w-4 h-4 inline-block mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M23.881 8.948c-.773-4.085-4.859-4.593-4.859-4.593H.723c-.604 0-.679.798-.679.798s-.082 7.324-.022 11.822c164.021 21.304 164.021 21.304 164.021 21.304h7.218s.493-.554.493-.619c0-.065.082-1.104.082-1.104s.604-7.324.604-7.324c0-.604-.604-.604-.604-.604h-7.218s-.604 0-.604.604c0 0 .082 1.104.082 1.104s.493.619.493.619h-7.218s-164.021-21.304-164.021-21.304c.041-4.498.022-11.822.022-11.822s-.075-.798.679-.798h18.299s4.086.508 4.859 4.593c.773 4.085.773 4.085.773 4.085s.082 7.324.082 11.822c0 0 .082 1.104.082 1.104s.493.619.493.619h7.218s.493-.554.493-.619c0-.065.082-1.104.082-1.104s.604-7.324.604-7.324c0-.604-.604-.604-.604-.604h-7.218s-.604 0-.604.604c0 0 .082 1.104.082 1.104s.493.619.493.619h-7.218s-164.021-21.304-164.021-21.304c.041-4.498.022-11.822.022-11.822s-.075-.798.679-.798h18.299s4.086.508 4.859 4.593c.773 4.085.773 4.085.773 4.085z"/>
            </svg>
            Buy me a coffee
          </a>
        </div>
      </div>
    </div>
  );
} 